import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

interface VerifyFormEmailAuthRequest {
  historyId: string;
  email: string;
  code: string;
}

export const verifyFormEmailAuth = (request: VerifyFormEmailAuthRequest) => {
  return api.post<ApiResponse<undefined>>(
    '/v2/viewer/submit/form-email-auth-verify',
    request,
  );
};

const useVerifyFormEmailAuth = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    VerifyFormEmailAuthRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  VerifyFormEmailAuthRequest,
  QueryKey
> => {
  return useMutation(verifyFormEmailAuth, options);
};

export default useVerifyFormEmailAuth;
